import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  authReducer,
  roomReducer,
  roomMessgesReducer,
  userReducer,
} from "./reducers";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducers = combineReducers({
  auth: persistReducer(persistConfig, authReducer),
  room: roomReducer,
  roomMessges: roomMessgesReducer,
  user: userReducer,
});

export const store = configureStore({
  reducer: rootReducers,
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
